<!--
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2023-05-25 19:05:44
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2024-04-29 10:59:56
 * @FilePath: \jyrg-web\src\components\pc\Header\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="content" id="nav">
    <header class="nav" v-if="$route.meta.title != '预约页'">
      <ul class="ulfather" id="ulfather">
        <!--创建父列-->
        <li
          class="lifather"
          v-for="item in menuList"
          :key="item.name"
          @click="navSkip(item)"
          @mouseover="mouseover(item)"
          @mouseleave="mouseleave"
        >
          <p>{{ item.name }}</p>
          <span class="underline"></span>
          <ul class="ulson" v-for="child in item.list" :key="child.name">
            <li class="lison" @click.stop="navSkip(child)">{{ child.name }}</li>
          </ul>
        </li>
        <!-- <li
          class="lifather"
          v-for="item in menuList.slice(0,3)"
          :key="item.name"
          @click="navSkip(item)"
          @mouseover="mouseover(item)"
          @mouseleave="mouseleave"
        >
          <p>{{item.name}}</p>
          <span class="underline"></span>
          <ul class="ulson" v-for="child in item.list" :key="child.name">
            <li class="lison" @click.stop="navSkip(child)">{{child.name}}</li>
          </ul>
        </li> -->
        <!-- <h1>
          <div class="logo">
            <img
              src="../../../assets/image/pc/logo.png"
              alt="logo,LOGO,Logo,站点logo,站点LOGO,站点Logo,不江湖"
              title="logo"
            />
          </div>
        </h1> -->
        <!-- <li
          class="lifather"
          v-for="item in menuList.slice(3)"
          :key="item.name"
          @click="navSkip(item)"
          @mouseover="mouseover(item)"
          @mouseleave="mouseleave"
        >
          <p>{{item.name}}</p>
          <span class="underline"></span>
          <ul class="ulson" v-for="child in item.list" :key="child.name">
            <li class="lison" @click.stop="navSkip(child)">{{child.name}}</li>
          </ul>
        </li> -->
      </ul>
      <!-- 官网1.0取消登录按钮 -->
      <div class="login">
        <a>欢迎您,{{ userInfo }}</a>
        <a v-if="userInfo == '****'" @click="orederAndLogin(true)">登录</a>
        <template v-else>
          <a @click="recordHandle()">礼包码</a>
          <a @click="loginOut()">注销</a>
        </template>
      </div>
    </header>

    <div
      class="dropdown-bg"
      id="dropdown-bg"
      :style="'height:' + navHeight"
    ></div>

     <!-- 充值 -->

        <VoucherIndexCenter
        ref="VoucherIndexCenter" 
       width="30%"
        @voucherShow="voucherCenterarHandle"
     ></VoucherIndexCenter>
    <VoucherIndexCenter
      
     v-if="voucherShow"
      :show="voucherShow"
      width="30%"
       @close="voucherCenterarHandle(false)"
    ></VoucherIndexCenter>

  <!-- 充值 -->
    <!-- 登录 -->
    <LoginDialog
        v-if="loginShow"
        :show="loginShow"
        class="myLoginDialog"
        @close="loginDialogClose(false)"
      ></LoginDialog>
        <!-- 登录 -->
                <!-- 礼包码 -->
        <template>
       <RecordDialog
      ref="RecordDialog"
      width="30%"
      @recordClose="recordHandle"
      ></RecordDialog>
      </template> 
         <!-- 礼包码 -->
  </div>

</template>
     
<script>
import { mapActions, mapMutations } from "vuex";
import webSite from "../../../api/webSite";
import "../../../assets/fonts/font.css";
import VoucherIndexCenter from "../../../components/public/VoucherIndexCenter";//充值弹框
import LoginDialog from "../../../components/public/LoginDialog";//登录弹框
import RecordDialog from "../../../components/public/recordDialog";

export default {

  data() {
    return {
      navHeight: "0px",
      voucherShow:false,
      loginShow:false,
      menuList: [
        { name: "官网首页", type: "parent", id: 0 },
        {
          name: "游戏攻略",
          type: "parent",
          id: 0,
          list: [],
        },
        {
          name: "资料大全",
          type: "parent",
          id: "",
          list: [
            {
              name: "版本介绍",
              type: "child",
              id: 5,
            },
            {
              name: "江湖资料",
              type: "child",
              id: 0,
            },
          ],
        },
        
        { name: "联系我们", type: "parent", id: "", list: [] },
        { name: "账号充值", type: "parent", id: "", list: [] },
      ],
    };
  },

  components: { VoucherIndexCenter,LoginDialog,RecordDialog},
  computed: {
    userInfo() {
      let info = this.$store.state.user.userInfo;
      info = info ? info : "****";
      return info;
    },

  },
  mounted() {
    this.initMenu();
  },
  methods: {
    ...mapActions({
      Logout: "user/Logout",

      searchStrategy: "base/searchStrategy",
      searchGameData: "base/searchGameData",
    }),
    ...mapMutations({
      LOGOUT: "user/LOGOUT",
      topUpDialog: "base/topUpDialog",
      loginDialog: "base/loginDialog",
      VoucherCenter: "base/VoucherCenter",
      recordDialogVisible: "user/recordDialogVisible",
      // loginShow: "base/loginShow",
    }),

    // 初始化菜单
    async initMenu() {

      // await this.searchGameData(); // 赛事汇总(menu)
      await this.searchStrategy(); // 游戏攻略(menu)

      // 获取赛事汇总 游戏攻略
   
      let res = await webSite.searchStrategy();

      const  list2= res.data[0].strategyEntity;

      let res2 = await webSite.searchStrategy();
      const  list3= res2.data[1].strategyEntity;
      // let store = JSON.parse(localStorage.getItem("store"));
      // const list2 = store.strategyList.find(
      //   (e) => e.strategyType == "游戏攻略"
      // ).strategyEntity;
      // const list3 = store.strategyList.find(
      //   (e) => e.strategyType == "联系我们"
      // ).strategyEntity;

      let gameStrategy = list2.slice(0, 5).map((e) => {
        return {
          name: e.title,
          type: "child",
          id: e.id,
        };
      });
      let contactUs = list3.slice(0, 5).map((e) => {
        return {
          name: e.title,
          type: "child",
          id: e.id,
        };
      });
      this.menuList = [
        { name: "官网首页", type: "parent", id: 0 },

        {
          name: "游戏攻略",
          type: "parent",
          id: 0,
          list: gameStrategy,
        },
        {
          name: "资料大全",
          type: "parent",
          id: 0,
          // list: [
          //   {
          //     name: "版本介绍",
          //     type: "child",
          //     id: 5,
          //   },
          //   {
          //     name: "江湖资料",
          //     type: "child",
          //     id: 0,
          //   },
          // ],
        },
        { name: "联系我们", type: "parent", id: 1, list: contactUs },
        { name: "账号充值", type: "parent", id: "", list: [] },
      ];
    },

    async navSkip(item) {
      let { id, path, type, name: title } = item;
      switch (title) {
        case "官网首页":
          this.$router.push({ path: "/home" });
          break;
        case "赛事汇总":
          this.$router.push({ path: "/information", query: { title } });
          break;
        case "游戏攻略":
          // 无操作
          break;
        case "资料大全":
        this.$router.push({ path: "/information", query: { title } });
          break;
        case "江湖资料":
          this.$router.push({ path: "/information", query: { title } });
          break;
        case "账号充值":
          // 弹窗
          this.voucherCenterarHandle(true);
          // this.topUpDialog(true);
          // 官网1.0充值功能未开放
          // alert("充值功能暂未开放，敬请期待！");
          break;
        case "官方社区":
          window.open("http://bbs.open1000y.com");
          break;
        case "联系我们":
          this.$router.push({
            path: "/detail",
            query: { id, title, type: "footer" },
          });

          break;
        default: {
          this.$router.push({ path: "/detail", query: { id, title, path } });
          break;
        }
      }
    },

    mouseover(item) {
      if (item.list.length) {
        this.navHeight = 37 * item.list.length + 150 + "px";
      }
    },

    // 鼠标移出
    mouseleave(ele) {
      this.navHeight = "0";
    },

    // 登录
    orederAndLogin(state) {
      this.loginShow=true;
    },
    //充值
    // voucherCenterarHandle(state) {
    //   this.$parent.$children[1].voucherCenterarHandle(true)
    // },

    voucherCenterarHandle(state) {
      this.$refs.VoucherIndexCenter.voucherShow = state;
    },
    //   //登录弹框关闭
      loginDialogClose(state) {
        this.loginShow=false;
      // this.loginDialog(state);
    },
    // 登出
    async loginOut() {
      try {
        await this.$confirm("是否退出登录?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        await this.Logout();
      } catch (error) {
        console.log(error);
      }
    },

    // 礼包码
    openRecordList() {
      this.recordDialogVisible(true);
    },
     //打开礼包码登录弹框
     recordHandle(state) { 
      this.$refs.RecordDialog.recordShow = true;
    },
  },

  
};
</script>

<style lang="scss" scoped>
.content {
  position: fixed;
  font-size: 18px;
  z-index: 1000;
  .nav {
    position: relative;
    width: 100%;
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url("~@/assets/image/pc/basemap-header.jpg") no-repeat center;
    background-size: 100% 100%;
    .logo {
      width: 151px;
      height: 92px;
      margin-left: 55px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    #ulfather {
      width: 1200px;
      display: flex;
      justify-content: space-around;
      height: 90px;
      line-height: 90px;
      cursor: pointer;
      margin-right: 55px;
    }
    .lifather {
      position: relative;
      width: 155px;
      padding: 0 20px;
      height: auto;
      text-align: center;
      color: #fff;
      font-family: "字体一";

      p {
        font-size: 30px;
      }
      .underline {
        -webkit-transform: scaleX(0);
        transform: scaleX(0);
      }
      p:hover + .underline {
        display: block;
        position: absolute;
        bottom: 0;
        width: 155px;
        height: 1px;
        background-color: #fff;
        -webkit-transition: all 0.55s ease-in 0s;
        transition: all 0.55s ease-in 0s;
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
      }
    }
    .lifather:hover {
      color: #fff;
    }

    .ulson {
      height: auto;
      color: rgb(250, 250, 250);
      display: none;
    }
    .ulson:hover {
      text-decoration: underline;
      text-underline-offset: 10px;
    }
    .lison {
      height: 25px;
      line-height: 25px;
      padding: 10px 0;
      font-size: 23px;
    }
    .lison:nth-child(1) {
      margin-top: 0;
    }

    .lifather:hover .ulson {
      display: block;
    }

    .lison:hover {
    }

    .login {
      display: flex;
      position: absolute;
      right: 1%;
      height: 90px;
      line-height: 90px;
      font-size: 20px;
      font-family: "字体一";
      a {
        color: #fff;
        margin: 0 15px;
        cursor: pointer;
      }
    }
  }

  .dropdown-bg {
    width: 1920px;
    background: linear-gradient(
      0deg,
      transparent 0%,
      rgba(0, 0, 0, 0.7) 46%,
      rgba(0, 0, 0, 0.7) 100%
    );
    transition: all 0.5s ease;
  }
}
</style>
